export default {
  apiUrl: 'https://api-v2.galerijabelgrade.com/api/v1',
  mediaUrl: process.env.REACT_APP_BASE_MEDIA_URL
};
